import { FolderKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFoldersSummaryRequest, GetFoldersSummaryResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useFoldersSummaryQuery(
  req: GetFoldersSummaryRequest,
  options?: SimpleQueryOptions<GetFoldersSummaryResponse, GetFoldersSummaryRequest>
) {
  return useBaseQuery({
    queryKey: [FolderKey.FoldersSummary, req.folderType, String(req.organizationId), req.includeDeletedResource, req.folderIds],
    fnOption: { url: FolderUrl.getFoldersSummary, request: req },
    ...options,
  });
}
